import PropTypes from "prop-types"
import { UUID, DATE } from "helpers/shapes"

export const TEAM_MEMBER = PropTypes.shape({
  id: UUID.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  teamRole: PropTypes.oneOf(["ADMIN", "MEMBER"]).isRequired,
  createdAt: DATE.isRequired,
  updatedAt: DATE.isRequired,
})
